import axios from '../../axios/index.js'
import store from '../../../store/store.js'


export default {
    getAllLeaveTypeLookup() {
        return axios.get('/api/lookup/leavetype/getAllLeaveType')
    },
    getAllClaimCategory() {
        return axios.get('/api/lookup/claimcategory/getAllClaimCategory')
    },
    getAllClaimSubCategory() {
        return axios.get('/api/lookup/claimsubcategory/getAllClaimSubCategory')
    },
    getAllLoanCategory() {
        return axios.get('/api/lookup/loancategory/getAllLoanCategory')
    },
    getAllLoanSubCategory() {
        return axios.get('/api/lookup/loansubcategory/getAllLoanSubCategory')
    },
    getAllDepartment() {
        return axios.get('/api/lookup/department/getAllDepartment')
    },
    getAllCreatePayrollTypeLookup() {
        return axios.get('/api/lookup/CreatePayrollType/getAllCreatePayrollType')
    },
    getAllBranch() {
        return axios.get('/api/lookup/Branch/getAllBranch')
    },
    getAllPosition() {
        return axios.get('/api/lookup/Position/getAllPosition')
    },
    getAllDivision() {
        return axios.get('/api/lookup/Division/getAllDivision')
    },
    getAllSection() {
        return axios.get('/api/lookup/Section/getAllSection')
    },
    getAllEmployeeCategory() {
        return axios.get('/api/lookup/EmployeeCategory/getAllEmployeeCategory')
    },
    getAllEarningsType() {
        return axios.get('/api/lookup/EarningsType/getAllEarningsType')
    },
    getAllDeductionsType() {
        return axios.get('/api/lookup/DeductionsType/getAllDeductionsType')
    },
    getAllCivilStatus() {
        return axios.get('/api/lookup/CivilStatus/getAllCivilStatus')
    },
    getAllNationality() {
        return axios.get('/api/lookup/Nationality/getAllNationality')
    },
    getAllReligion() {
        return axios.get('/api/lookup/Religion/getAllReligion')
    },
    getAllRelationshipLookup() {
        return axios.get('/api/lookup/Relationship/getAllRelationship')
    },
    getAllOvetimeType() {
        return axios.get('/api/lookup/overtimetype/getAllOvertimeType')
    },
    getAllAccreditationType() {
        return axios.get('/api/lookup/Accreditationtype/getAllAccreditationType')
    },
    getAllRankLookup() {
        return axios.get('/api/lookup/Rank/getAllRank')
    },
    getAllAssociationLookup() {
        return axios.get('/api/lookup/Association/getAllAssociation')
    },
    getAllBankLookup() {
        return axios.get('/api/lookup/Bank/getAllBank')
    },
    getAllPeriodLookup() {
        return axios.get('/api/lookup/Period/getAllPeriod')
    },
    getAllBenefitTypeLookup() {
        return axios.get('/api/lookup/BenefitType/getAllBenefitType')
    },
    getAllLineOfBusinessLookup() {
        return axios.get('/api/lookup/LineOfBusiness/getAllLineOfBusiness')
    },
    getAllDegreeLookup() {
        return axios.get('/api/lookup/Degree/getAllDegree')
    },
    getAllAreaOfStudyLookup() {
        return axios.get('/api/lookup/AreaOfStudy/getAllAreaOfStudy')
    },
    getAllInstitutionLookup() {
        return axios.get('/api/lookup/Institution/getAllInstitution')
    },
    getAllAwardLookup() {
        return axios.get('/api/lookup/Award/getAllAward')
    },
    getAllAppraisalRatingLookup() {
        return axios.get('/api/lookup/AppraisalRating/getAllAppraisalRating')
    },
    getAllAppraisalTypeLookup() {
        return axios.get('/api/lookup/AppraisalType/getAllAppraisalType')
    },
    getAllMarketSegmentLookup() {
        return axios.get('/api/lookup/MarketSegment/getAllMarketSegment')
    },
    getAllSalaryBasedOnLookup() {
        return axios.get('/api/lookup/SalaryBasedOn/getAllSalaryBasedOn')
    },
    getAllScheduleNumber() {
        return axios.get('/api/lookup/ScheduleNumber/getAllScheduleNumber')
    },
    getAllTaxReferenceLookup() {
        return axios.get('/api/lookup/TaxReference/getAllTaxReference')
    },
    getAllPaymentModeLookup() {
        return axios.get('/api/lookup/PaymentMode/getAllPaymentMode')
    },
    getAllViolationActionLookup() {
        return axios.get('/api/lookup/ViolationAction/getAllViolationAction')
    },
    getAllViolationLookup() {
        return axios.get('/api/lookup/Violation/getAllViolation')
    },
    getAllMedicalProcedureLookup() {
        return axios.get('/api/lookup/MedicalProcedure/getAllMedicalProcedure')
    },
    getAllCountryLookup(source) {
        return axios.get('/api/util/timezones', { params: { source: source}})
    },
}